<template>
  <div>
    <div class="card mb-4">
      <div class="card-body p-4 p-md-5">
        <p>
          {{ $t("iq_affidavit_1") }}
        </p>
        <p>
          {{ $t("iq_affidavit_2") }}
        </p>
        <p class="mt-4 pt-3">
          <a href="" target="_blank" class="text-highlighted"
            ><font-awesome-icon icon="info-circle" class="mr-2" />
            {{ $t("iq_more_information") }}
          </a>
        </p>
      </div>
    </div>
    <investment-questionnaire-form />
  </div>
</template>

<script>
import InvestmentQuestionnaireForm from "../components/InvestmentQuestionnaireForm";

export default {
  name: "InvestmentQuestionnaire",
  components: {
    InvestmentQuestionnaireForm
  }
};
</script>
